import React from 'react';
import { IBinning } from '../../../../../../redux/slices/oldBuilder/binning/types';
import { BucketDefType } from '../../../../../../utils/apollo/graphqlSchema';
import { VersionedEntity } from '../../../../../../components/EntityLabels';
import BuilderInfo from '../../../../../../components/BuilderInfo';

interface IProps {
  selectedBinning: IBinning;
  onClear: () => void;
}

const HistogramBinningDisplay = ({ selectedBinning, onClear }: IProps) => {
  if (selectedBinning.type === BucketDefType.Named) {
    const namedBucketDef = selectedBinning.namedBucketDef;

    return (
      <VersionedEntity
        label={namedBucketDef.name}
        isDisabled={namedBucketDef.isDisabled}
        onClear={onClear}
        isLatestVersion
      >
        <BuilderInfo kind="namedBucketDef" namedBucketDef={namedBucketDef} />
      </VersionedEntity>
    );
  }

  return (
    <VersionedEntity
      label={'Custom'}
      isDisabled={false}
      onClear={onClear}
      isLatestVersion
    >
      <BuilderInfo kind="basicBucketDef" basicBucketDef={selectedBinning} />
    </VersionedEntity>
  );
};

export default HistogramBinningDisplay;
